<template>
  <div class="getway-detail">
    <div class="getway-detail-table">
      <div class="table_tabs">
        <!-- 头部 -->
        <div class="video-tab">
          <div
            v-for="item in tabOption.column"
            :key="item.typeId"
            :class="['tab', recordType == item.typeId ? 'active' : '']"
            @click="handleChange(item)"
          >
            {{ item.label }}
          </div>
        </div>
        <div
          v-if="checkLeftType.typeId == 3"
          class="point-icon iconfont-lunan icon-lunan-gengduoda ml10"
          @click.stop="
            () => {
              searchFormShow = !searchFormShow;
            }
          "
        ></div>
      </div>
      <el-collapse-transition>
        <div class="list-search" v-if="searchFormShow && checkLeftType.typeId == 3">
          <div
            class="search_item"
            :class="recordListType == 1 && 'check'"
            @click="queryRecord('1')"
          >
            人员通行记录
          </div>
          <div
            class="search_item"
            :class="recordListType == 2 && 'check'"
            @click="queryRecord('2')"
          >
            车辆通行记录
          </div>
        </div>
      </el-collapse-transition>
      <div class="gate" v-show="recordType == '1'">
        <div class="gate_check">
          <label>已选： {{ checkGateList.length }} </label>

          <div>
            <el-button type="info" @click="addLocal" style="padding: 6px 14px !important"
              >添加到值守方案</el-button
            >
          </div>
        </div>
        <div class="gate_body">
          <el-scrollbar
            class="el-scrollbar"
            v-loading="deviceLoading"
            element-loading-text="加载中..."
            element-loading-spinner="el-icon-loading"
          >
            <div class="">
              <el-checkbox-group v-model="checkGateList">
                <div class="gate_item" v-for="item in deviceData" :key="item.sceneCode">
                  <div class="item_label" :title="item.sceneName">
                    <el-checkbox :label="item.sceneCode">
                      {{ item.sceneName }}
                    </el-checkbox>
                  </div>
                  <span
                    title="播放中"
                    v-if="liveDeviceIds[0].includes(item.sceneCode)"
                    class="liveImg"
                  >
                    <img src="@src/common/assets/images/直播中.png" alt="" />
                  </span>
                  <div class="item_btn">
                    <el-button
                      type="text"
                      title="播放"
                      @click.stop="handlePlay(item, 0)"
                      class="el-icon-video-play btn"
                    ></el-button>
                    <el-button
                      title="详情"
                      @click.stop="handleOpenDetail(item)"
                      type="text"
                      class="iconfont icon-Detail btn"
                    ></el-button>
                  </div>
                </div>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="plan_list list-content" v-show="recordType == '2'">
        <el-scrollbar style="height: 100%">
          <div
            class="list-item"
            v-for="(items, index) in planList"
            :key="items.plateCode"
          >
            <div class="item-title" @click="items.show = !items.show">
              <span class="item-name">
                方案 {{ index + 1 }} ： {{ items.planSceneName }}
              </span>
              <span>
                <el-button
                  type="text"
                  @click.stop="startPlan(items, index)"
                  class="el-icon-video-play btn"
                  size="mini"
                  title="启动"
                ></el-button>
                <el-button
                  type="text"
                  @click.stop="removePlan(items)"
                  class="el-icon-delete-solid btn"
                  size="mini"
                  title="删除"
                ></el-button>
                <el-button
                  :title="items.show ? '收起' : '展开'"
                  type="text"
                  :class="items.show ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
                ></el-button>
              </span>
            </div>
            <el-collapse-transition>
              <ul class="itemChildren" v-show="items.show">
                <li
                  v-for="(item, childrenIndex) in items.children"
                  :key="childrenIndex"
                  class="list-text"
                  @click="handleNodeClick(item)"
                >
                  <!-- item.sceneCode == checkPlan.sceneCode ? 'check' : '', -->

                  <span class="item-name item-over">{{ item.sceneName | ellipsis }}</span>
                  <span
                    title="播放中"
                    v-if="
                      liveDeviceIds[1].includes(item.sceneCode) &&
                      liveDevicePlanIds.includes(items.planSceneCode)
                    "
                    class="liveImg"
                  >
                    <img src="@src/common/assets/images/直播中.png" alt="" />
                  </span>
                  <span class="item-btn">
                    <el-button
                      type="text"
                      title="播放"
                      @click="handlePlay(item, 1)"
                      class="el-icon-video-play btn"
                    ></el-button>
                    <el-button
                      title="详情"
                      @click="handleOpenDetail(item)"
                      type="text"
                      class="iconfont icon-Detail btn"
                    ></el-button>
                  </span>
                </li>
              </ul>
            </el-collapse-transition>
          </div>
        </el-scrollbar>
      </div>
      <div class="record-list" v-show="recordType == '3'">
        <el-scrollbar ref="recordList">
          <div class="scroll-list">
            <div
              class="list-item map-blur-panel__list-item"
              v-for="item in passList"
              :key="item.recordCode"
              @click.stop="handleView(item)"
            >
              <div class="item_img">
                <img
                  style="width: 100%; height: 100%"
                  onerror="this.src='/images/theme/newDark/default.png'"
                  :src="
                    getImageUrl(
                      passRecordType == '1'
                        ? item.personnelFileCode
                        : item.trafficFileCode
                    )
                  "
                />
              </div>
              <div class="item_detail">
                <div class="detail_header">
                  <div>
                    <span v-if="passRecordType == '1'">{{ item.name }}</span>
                    <span v-else>{{ item.plateCode }}</span>
                    <span v-if="item.personnelType == 1 && item.jobNo"
                      >({{ item.jobNo }})</span
                    >
                  </div>
                  <div>
                    <div class="" v-if="passRecordType == '1'">
                      {{ item.personnelType == 1 ? "内部员工" : "外来人员" }}
                    </div>
                    <div class="" v-else>
                      {{ item.trafficType == 1 ? "员工车辆" : "外来车辆" }}
                    </div>
                  </div>
                </div>
                <div class="detail_value">
                  {{ item.trafficTime }}
                </div>
                <div class="detail_value">
                  {{ item.deviceName }}
                </div>
              </div>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </div>
    <div style="flex: 1">
      <div class="getway-info">
        <div class="ocx-box">
          <playerBox
            ref="player"
            :isAddBtn="true"
            :isShowRightTitle="true"
            @addBtnClick="handleScenceDetail"
            @handleLiveSuccess="handleLiveSuccess"
            @handlePlayLiveClose="handlePlayLiveClose"
          ></playerBox>
        </div>
        <div class="getway-btns">
          <div class="left-icon">
            <el-tooltip
              class="item"
              effect="dark"
              content="关闭所有视频"
              placement="top-start"
            >
              <img
                @click="handleStopAll"
                class="img"
                src="@src/common/assets/images/结束录像.png"
                alt=""
              />
            </el-tooltip>
          </div>
          <div class="middle-icon">
            <div class="getway-control_list" v-if="isShowVoice">
              <el-scrollbar class="el-scrollbar">
                <div
                  class="getway-control_list--item"
                  v-for="item in voiceList"
                  :key="item.scenceCode"
                  @click="handleOpenDetailAlarm(item)"
                >
                  <span>{{ item.deviceName }}</span>
                </div>
              </el-scrollbar>
            </div>

            <div
              class="getway-control_item"
              :class="voiceList.length > 0 ? 'getway-control_hight' : ''"
              @click="handleOpenAlarm"
            >
              <i class="icon iconfont-lunan icon-lunan-maikefeng"></i>
              <div class="bg" v-if="voiceList.length > 0"></div>
              对讲
            </div>
          </div>
          <div class="right-icon">
            <el-tooltip class="item" effect="dark" content="一分屏" placement="top-start">
              <img
                class="img"
                @click="handleWindow(1)"
                src="@src/common/assets/images/1分屏.png"
                alt=""
              />
            </el-tooltip>
            <div style="margin: 0 8px">
              <div class="screenTip" v-if="showScreenTip">
                <div
                  v-for="item in screenTypeList"
                  :key="item"
                  class="screenTip_item"
                  @click="handleWindow(+item)"
                >
                  <img
                    :src="require(`@src/common/assets/images/${item}分屏.png`)"
                    onerror="@src/common/assets/images/1分屏.png"
                    alt=""
                  />
                  {{ item }}分屏
                </div>
              </div>

              <span @click="showScreenTip = !showScreenTip">
                <img
                  style="cursor: pointer"
                  :src="require(`@src/common/assets/images/${windowNumber}分屏.png`)"
                  onerror="@src/common/assets/images/1分屏.png"
                  alt=""
                />
                <i
                  class="changIcon"
                  :class="!showScreenTip ? 'el-icon-caret-bottom' : 'el-icon-caret-top'"
                ></i>
              </span>
            </div>

            <el-tooltip class="item" effect="dark" content="全屏" placement="top-start">
              <img
                class="img"
                @click="handleScreen"
                src="@src/common/assets/images/全屏.png"
                alt=""
              />
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <appPanel
      :width="342"
      position="left"
      class="app-panel"
      :isExpand="showPersonPanel"
      @cancel="handleClosePanel"
      :title="passRecordType == '1' ? '人员档案简要信息' : '通行信息'"
    >
      <!--人员通行记录-->
      <div class="panel-content" v-if="passRecordType == '1'">
        <div class="content-top">
          <div class="top_img">
            <img
              class="img"
              @click="showViewer(panelDetail.personnelFileCode, $event)"
              onerror="this.src='/images/theme/newDark/default.png'"
              :src="getImageUrl(panelDetail.personnelFileCode)"
            />
          </div>
        </div>
        <div class="content-buttom">
          <div class="item_value">
            <div class="label">人员姓名 :</div>
            <span class="paddingL10">{{ panelDetail.name }}</span>
          </div>
          <div class="item_value">
            <div class="label">人员工号 :</div>
            <span class="paddingL10">{{ panelDetail.jobNo }}</span>
          </div>
          <div class="item_value">
            <div class="label">认证方式 :</div>
            <span class="paddingL10">{{ panelDetail.verifyModeName }}</span>
          </div>
          <div class="item_value">
            <div class="label">门禁区域 :</div>
            <span class="paddingL10">{{ panelDetail.areaDevGroupName }}</span>
          </div>
          <div class="item_value">
            <div class="label">设备名称 :</div>
            <span class="paddingL10">{{ panelDetail.deviceName }}</span>
          </div>
          <div class="item_value">
            <div class="label">读头名称 :</div>
            <span class="paddingL10">{{ panelDetail.readerName }}</span>
          </div>
          <div class="item_value">
            <div class="label">通行时间 :</div>
            <span class="paddingL10">{{ panelDetail.trafficTime }}</span>
          </div>
        </div>
      </div>
      <!--车辆通行记录-->
      <div class="panel-content" v-else>
        <div class="content-top">
          <div class="top_img">
            <img
              class="img"
              @click="showViewer(panelDetail.trafficFileCode, $event)"
              onerror="this.src='/images/theme/newDark/default.png'"
              :src="getImageUrl(panelDetail.trafficFileCode)"
            />
          </div>
        </div>
        <div class="content-buttom">
          <div class="item_value">
            <div class="label">车主姓名</div>
            <span class="paddingL10">{{ panelDetail.name }}</span>
          </div>
          <div class="item_value">
            <div class="label">车主电话</div>
            <span class="paddingL10">{{ panelDetail.phone }}</span>
          </div>
          <div class="item_value">
            <div class="label">车牌号码</div>
            <span class="paddingL10">{{ panelDetail.plateCode }}</span>
          </div>
          <div class="item_value">
            <div class="label">车辆类型</div>
            <span class="paddingL10">{{
              panelDetail.trafficType === "1" ? "员工车辆" : "外来车辆"
            }}</span>
          </div>
          <div class="item_value">
            <div class="label">通道名称</div>
            <span class="paddingL10">{{ panelDetail.deviceName }}</span>
          </div>
          <div class="item_value">
            <div class="label">通行时间</div>
            <span class="paddingL10">{{ panelDetail.trafficTime }}</span>
          </div>
        </div>
      </div>
    </appPanel>
    <el-dialog title="保存为常用方案" :visible.sync="showLocalDialog" width="500px">
      <el-form :model="localForm" label-width="100px" :rules="rules" ref="form">
        <el-form-item label="保存方式">
          <el-radio-group v-model="planWay" @change="handleChangeWay">
            <el-radio :label="1">新的常用方案</el-radio>
            <el-radio :label="2">替换现有方案</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="方案名称" prop="planSceneName" v-if="planWay == 1">
          <el-input
            v-model="localForm.planSceneName"
            placeholder="请输入方案名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="方案名称" prop="planScene" v-if="planWay == 2">
          <el-select
            v-model="localForm.planScene"
            placeholder="请选择替换方案"
            style="width: 100%"
          >
            <el-option
              v-for="item in planList"
              :key="item.planSceneCode"
              :label="item.planSceneName"
              :value="item.planSceneCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="cancelLocal" :loading="btnLoading">{{
          btnLoading ? "保存中" : "取消"
        }}</el-button>
        <el-button type="primary" @click="saveLocal" :loading="btnLoading">{{
          btnLoading ? "保存中" : "保存"
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 出入口详情 -->
    <appPanel
      :width="850"
      class="app-panel"
      style="z-index: 3"
      :isExpand="showGatePanel"
      isScreen
      @cancel="handleCloseGatePanel"
      :title="'出入口 * ' + sceneDetail.sceneName"
    >
      <range-control ref="rangeControl"></range-control>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseGatePanel" type="info"> 关闭 </el-button>
      </span>
    </appPanel>
  </div>
</template>

<script>
import { getwayControl } from "../api";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus } from "$utils";
import playerBox from "../components/player-box.vue";
import rangeControl from "./rangeControl.vue";
import { mapState } from "vuex";
export default {
  components: {
    appPanel,
    playerBox,
    rangeControl,
  },
  data() {
    return {
      deviceLoading: false,
      isShowVoice: false,
      btnLoading: false,
      liveDeviceIds: [[], []], //缓存出入口播放信息
      liveDevicePlanIds: [], //缓存方案播放信息
      recordListType: 1,
      checkPlan: {},
      screenTypeList: [4, 6, 9, 13, 16, 25],
      showScreenTip: false,
      checkGateList: [],
      checkLeftType: {},
      checked: [],
      showPersonPanel: false,
      showGatePanel: false,
      panelDetail: {},
      page: {
        pageNum: 1,
        total: 0,
        pageSize: 30, //utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchText: "",
      tableData: [],
      recordType: "1",
      detailData: {},
      passList: [],
      imgUrl: "",
      tabOption: {
        column: [
          {
            label: "出入口",
            prop: "car",
            typeId: "1",
          },
          {
            label: "值守方案",
            prop: "car",
            typeId: "2",
          },
          {
            label: "通行记录",
            prop: "car",
            typeId: "3",
          },
        ],
      },
      thirdDeviceIdList: [],
      sceneList: [],
      searchFormShow: false,
      passRecordType: "1",
      deviceData: [],
      planList: [], //值守方案
      showLocalDialog: false,
      localForm: { planScene: "", planSceneName: "" },
      rules: {
        planScene: [
          {
            required: true,
            message: "请选择替换方案",
            trigger: ["blur", "change"],
          },
        ],
        planSceneName: [
          {
            required: true,
            message: "请输入方案名称",
            trigger: ["blur", "change"],
          },
        ],
      },
      planWay: 1,
      windowNumber: 4,
      sceneCode: "",
      sceneDetail: {},
      getTimeOut: null,
    };
  },
  computed: {
    ...mapState({
      voiceList: (state) => state.common.broadcastMessage,
    }),
  },
  watch: {
    voiceList: {
      handler(newVal, oldVal) {
        console.log(newVal);
      },
    },
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  mounted() {
    this.scrollbar(); //添加滚动事件
    this.getRecordList(); //获取通行记录
    this.getDeviceSceneList(); //出入口配置
    this.getDeviceScenePlanList(); //值守方案
  },
  methods: {
    scrollbar() {
      let recordList = this.$refs.recordList;
      this.boxScrollContainer = recordList.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
            this.scrollView.clientHeight &&
          !this.isLastPage &&
          !this.dataLoading
        ) {
          this.page.pageNum = this.page.pageNum + 1;
          this.getRecordList();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    // 方案组点击回调
    handleNodeClick(data) {
      this.checkPlan = data;
    },
    handleScreen() {
      const el = document.getElementById("player_wrap");
      const isFull =
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement;
      if (isFull) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      } else {
        (el.requestFullscreen && el.requestFullscreen()) ||
          (el.mozRequestFullScreen && el.mozRequestFullScreen()) ||
          (el.webkitRequestFullscreen && el.webkitRequestFullscreen()) ||
          (el.msRequestFullscreen && el.msRequestFullscreen());
      }
    },
    //切换窗口
    handleWindow(num) {
      this.$refs.player.windowNumber = num;
      this.windowNumber = num;
      this.showScreenTip = false;
    },
    playVideoClose(index) {
      let bf2 = [...this.$refs.player.showIconVideo()];
      this.$nextTick(() => {
        this.$emit("playVideoOK", bf2);
      });
    },
    // 语音告警
    handleOpenAlarm() {
      if (this.voiceList.length == 0) {
        this.$message.warning("暂无语音设备上报");
        return;
      }
      this.isShowVoice = !this.isShowVoice;
    },
    // 推送详情
    handleOpenDetailAlarm(item) {
      this.isShowVoice = !this.isShowVoice;
      this.$store.commit("REMOVE_BROADCAST_MESSAGE", item);
      this.handleOpenDetail(item);
    },
    // 出入口详情
    handleOpenDetail(data) {
      this.queryDeviceSceneDetail2(data.sceneCode).then((res) => {
        this.showGatePanel = true;
        this.$refs.rangeControl.handleOpen(this.sceneDetail);
      });
    },
    // 关闭出入口详情
    handleCloseGatePanel() {
      this.showGatePanel = false;
      this.$refs.rangeControl.handleClose();
    },
    //出入口配置
    getDeviceSceneList(type) {
      this.deviceLoading = true;
      this.$fetch(getwayControl.queryDeviceSceneList, {
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        setTimeout(() => {
          this.deviceLoading = false;
        }, 500);
        if (res.success) {
          this.deviceData = res.returnObj.list;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //配置方案详情
    getDeviceScenePlanList() {
      this.$fetch(getwayControl.queryDeviceScenePlanList, {
        pageNum: 1,
        pageSize: 1000,
      }).then((res) => {
        if (res.success) {
          this.planList = res.returnObj.list.map((item, index) => {
            return {
              planSceneCode: item.planSceneCode,
              planSceneName: item.planSceneName,
              children: [],
              show: index == 0 ? true : false,
            };
          });
          this.planList.forEach((item) => {
            item.children.length = 0;
            this.$fetch(getwayControl.queryDeviceScenePlanDetail, {
              planSceneCode: item.planSceneCode,
            }).then((reEl) => {
              if (reEl.success) {
                reEl.returnObj.deviceScenePlanDetailList.forEach((items) => {
                  item.children.push({
                    ...items,
                    planSceneCode: item.planSceneCode,
                    planSceneName: item.planSceneName,
                  });
                });
              }
            });
          });
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    //移除方案
    removePlan(data) {
      this.$confirm("您确定删除该值守方案吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(getwayControl.deleteDeviceScenePlan, {
          planSceneCode: data.planSceneCode,
        }).then((res) => {
          if (res.success) {
            this.$message.success("删除方案成功！");
            this.getDeviceScenePlanList();
          } else {
            this.$message.error(res.msgContent);
          }
        });
      });
    },
    handleStopAll() {
      this.$refs.player.handleStopAllVideo();
    },
    // 值守方案播放
    startPlan(data, index) {
      data.show = true;
      console.log(data, "=====data");
      if (data.children.length == 0) {
        this.$message.warning("该方案暂无出入口配置");
        return;
      }
      if (this.$refs.player.deviceRecord) {
        this.$refs.player.handleStopAllVideo();
      }
      this.$refs.player.setWndNumber(data.children.length);
      data.children.forEach((el, ind) => {
        setTimeout(() => {
          this.$refs.player.handlePlayLive(
            {
              name: el.defaultDeviceSceneDetail.deviceName,
              thirdCameraId: el.defaultDeviceSceneDetail.thirdDeviceId,
              sceneCode: el.sceneCode,
              type: 1,
              planSceneCode: data.planSceneCode,
              rightTitle: "方案 * " + data.planSceneName + "[" + el.sceneName + "]",
            },
            ind + 1,
            {
              tip: "详情",
              id: "detail",
              class: "detailBtn",
            }
          );
        }, 150);
      });
    },
    handleChangeWay(data) {
      this.planWay = data;
      this.localForm.planSceneName = "";
    },

    handleClosePanel() {
      this.showPersonPanel = false;
    },
    //添加到方案
    addLocal() {
      if (this.checkGateList.length == 0) {
        this.$message.warning("请选择出入口配置后提交！");
        return;
      }
      if (this.checkGateList.length > 16) {
        this.$message.warning("方案一次最多支持配置16条出入口配置");
        return;
      }
      this.showLocalDialog = true;
    },
    saveLocal() {
      this.$refs.form.validate((res) => {
        if (!res) {
          return;
        }
        let params = {};
        let planSceneCode = this.localForm.planScene;
        let api = getwayControl.addDeviceScenePlan;
        if (this.planWay == 2) {
          api = getwayControl.updateDeviceScenePlan;
          let arr = [];
          arr = this.planList.filter(function (item) {
            return planSceneCode == item.planSceneCode;
          });
          params.planSceneCode = arr[0].planSceneCode;
          params.planSceneName = arr[0].planSceneName;
        } else {
          params.planSceneName = this.localForm.planSceneName;
        }
        params.deviceScenePlanDetailList = this.checkGateList.map((item) => {
          return {
            sceneCode: item,
          };
        });
        this.btnLoading = true;
        this.$fetch(api, params).then((res) => {
          this.btnLoading = false;
          if (res.success) {
            this.$message.success("方案添加成功");
            this.cancelLocal();
            this.checkGateList = [];
            this.getDeviceScenePlanList();
          } else {
            this.$message.error(res.msgContent || "方案添加失败");
          }
        });
      });
    },
    cancelLocal() {
      this.showLocalDialog = false;
      this.$refs.form.resetFields();
    },
    handleView(data) {
      this.showPersonPanel = true;
      this.panelDetail = data;
    },
    // 视频播放成功
    handleLiveSuccess(device) {
      console.log(device);
      if (device.planSceneCode) {
        this.liveDevicePlanIds.push(device.planSceneCode);
      }
      this.liveDeviceIds[device.type].push(device.sceneCode);
    },
    // 视频关闭
    handlePlayLiveClose(device) {
      let indexLive = this.liveDeviceIds[device.type].indexOf(device.sceneCode);
      let indexLivePlan = this.liveDevicePlanIds.indexOf(device.planSceneCode);
      this.liveDeviceIds[device.type].splice(indexLive, 1);
      this.liveDevicePlanIds.splice(indexLivePlan, 1);
    },
    // 出入口详情按钮
    handleScenceDetail(data) {
      this.handleOpenDetail(data);
    },
    // 出入口播放
    handlePlay(val, type) {
      console.log(val);
      if (!Object.keys(this.$refs.player.playRecord).length) {
        this.$message.warning("视频播放插件加载中，请稍后重试");
        return;
      }
      let detailObj = {};
      this.$fetch(getwayControl.queryDeviceSceneDetail, {
        sceneCode: val.sceneCode,
      }).then((res) => {
        if (res.success) {
          detailObj = res.returnObj || {};
          this.$refs.player.handlePlayLive(
            {
              thirdCameraId: detailObj.defaultDeviceSceneDetail.thirdDeviceId,
              name: detailObj.defaultDeviceSceneDetail.deviceName,
              sceneCode: detailObj.sceneCode,
              type: type,
              planSceneCode: val.planSceneCode,
              rightTitle:
                type == 0
                  ? "出入口 *  " + detailObj.sceneName
                  : "方案 * " + val.planSceneName + "[" + detailObj.sceneName + "]",
            },
            "",
            {
              tip: "详情",
              id: "detail",
              class: "detailBtn",
            }
          );
        } else {
          this.$message.error(res.msgContent || "获取出入口详情失败");
        }
      });
    },
    handleChange(column) {
      this.searchFormShow = false;
      this.checkLeftType = column;
      this.recordType = column.typeId;
    },

    queryRecord(type) {
      this.recordListType = type;
      this.handSetTime();
      this.passList = [];
      this.page.pageNum = 1;
      this.searchFormShow = false;
      this.getRecordList();
    },
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.queryRecord();
      }, 1000 * 60 * 2);
    },
    //通行记录
    getRecordList() {
      let type = this.recordListType;
      this.passRecordType = type;
      let params = {
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum,
      };
      this.dataLoading = true;
      let api = getwayControl.getPersonRecordList;
      if (type && type == "1") {
        api = getwayControl.getPersonRecordList;
      } else if (type && type == "2") {
        api = getwayControl.getVehicleRecordList;
      }
      this.$fetch(api, params).then((res) => {
        setTimeout(() => {
          this.dataLoading = false;
        }, 500);
        if (res.success) {
          this.isLastPage = res.returnObj.isLastPage;
          this.passList = this.passList.concat([...res.returnObj.list]);
        }
      });
    },
    getImageUrl(fileCode) {
      return fileCode ? Bus.imgPath(fileCode) : "";
    },
    getDicLabel(senu, value) {
      return Dic.findByValue(senu, value);
    },
    showViewer(src, e) {
      let viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.$app.AppInstance.handleShowViewer([viewerPhotos]);
    },
    switchControl(cmdType) {
      const optStr = cmdType === 1 ? "打开" : "关闭";
      this.$confirm("确定" + optStr + "所有道闸吗？", "操作确认", {
        type: "warning",
      })
        .then((res) => {
          this.$fetch(getwayControl.batchControlVehicleBarrier, {
            cmdType,
          }).then((res) => {
            if (res.success) {
              this.$message.success(optStr + "所有道闸成功");
            } else {
              this.$message.error(res.msgContent || optStr + "所有道闸失败");
            }
          });
        })
        .catch((e) => {
          this.$log.info("用户取消" + optStr + "所有道闸操作");
        });
    },
    queryDeviceSceneDetail2(item) {
      let that = this;
      return new Promise(function (resolve, reject) {
        that
          .$fetch(getwayControl.queryDeviceSceneDetail, { sceneCode: item })
          .then((res) => {
            if (res.success) {
              that.sceneDetail = res.returnObj || {};
              resolve(that.sceneDetail);
            } else {
              reject(res.msgContent);
            }
          });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

.getway-control {
  // margin-top: 30px;
  &_list--item {
    cursor: pointer;
    padding: 10px;
    color: #c9d5ec;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    &:hover {
      background: rgba(56, 63, 110, 1);
    }
  }
  &_list {
    border: 1px solid #3e76e6;
    position: absolute;
    bottom: 40px;
    padding: 10px 0;
    width: 220px;
    max-height: 245px;
    background: rgba(25, 29, 49, 1);
    box-shadow: 10px 0px 10px rgba(0, 0, 0, 0.9);
    border-radius: 5px;
  }
  &_hight {
    background: rgba(64, 122, 238, 1) !important;
  }

  &_item {
    width: 100px;
    height: 32px;
    line-height: 32px;
    border-radius: 5px;
    background: rgba(75, 85, 102, 1);
    border: 1px solid #3b4253;
    margin-right: 10px;
    text-align: center;
    cursor: pointer;
    position: relative;
    &:hover {
      background: rgba(64, 122, 238, 1);
    }
    .bg {
      -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
      animation: stretchdelay 1.2s infinite ease-in-out;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      position: absolute;
      top: 5px;
      left: 40px;
      background-image: radial-gradient(rgba(235, 44, 44, 0.2), rgba(255, 24, 24, 0.6));
    }
    @keyframes stretchdelay {
      100% {
        transform: translate(-2px, -5px);
        width: 35px;
        height: 35px;
        border-radius: 50%;
      }
      0% {
        transform: translate(8px, 10px);
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
    }
  }
}
.ocx-box {
  height: calc(100% - 80px);
  @include set_theme_color(background-color, left-menu-bg-color);
  padding: 12px;
}
.list_item {
  // padding: 14px 0px;
  width: 100%;
  .item_name {
    padding-left: 20px;
  }
}
.gate_check {
  display: flex;
  justify-content: space-between;
  margin: 12px 0px 8px;
  align-items: center;
}
.gate {
  height: calc(100% - 30px);
  position: relative;
  width: 100%;

  &_body {
    margin-top: 12px;
    height: calc(100% - 50px);
    // background: #1e2534;
    padding: 0 1px;
  }
  &_item {
    display: flex;
    justify-content: space-between;
    height: 40px;
    line-height: 40px;
    padding: 0px 12px;
    border-bottom: 1px solid #3b4253;
    @include set_theme_color(border-color, border-color);

    .liveImg {
      padding-top: 10px;
    }
    // background: rgba(13, 18, 28, 1);
    &:hover {
      // background: rgba(13, 18, 28, 1);
      .liveImg {
        display: none;
      }
      .item_btn {
        display: block;
      }
    }
  }
  .item_label {
    width: 80%;
  }
  .item_btn {
    display: none;
    .btn {
      color: #fff;
      font-size: 18px;
      height: 40px;
    }
  }
}

.el-select-dropdown__list {
  // width: 200px;
}
.app-side-panel__header {
  // -left: 10px;
  .title {
    padding: 0px 6px;
    // border-left: 4px solid #407aee;
  }
}
//方案
//操作按钮
.getway-btns {
  height: 56px;
  padding: 0 12px;
  @include set_theme_color(background-color, left-menu-bg-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  .right-icon,
  .left-icon,
  .middle-icon {
    display: flex;
    align-items: center;
    position: relative;
  }
  .middle-icon {
    margin-left: 100px;
  }
  .screenTip {
    position: absolute;
    top: -110px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    width: 200px;
    right: -12px;
    padding: 10px;
    border-radius: 5px;
    border: 1px solid royalblue;
    z-index: 3;
    @include set_theme_color(background-color, left-menu-bg-color);
    &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 67%;
      border-width: 8px;
      border-style: solid;
      border-color: royalblue transparent transparent transparent;
    }
    &_item {
      width: 43%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      &:hover {
        color: royalblue;
      }
    }
  }
  .changIcon {
    font-size: 20px;
    position: relative;
    top: -4px;
    margin-left: 3px;
    cursor: pointer;
  }
  .img {
    cursor: pointer;
  }
}
.getway-detail {
  overflow: auto;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  height: 100%;
  .scene-label {
    width: 120px;
    line-height: 32px;
  }
  .player-content {
    border: 1px solid rgba(0, 0, 0, 0.8);
  }
  .two-player {
    flex: 1;
    &:last-child {
      margin-left: 10px;
    }
    .getway-info-card-body {
      height: 430px;
    }
  }
  //人员信息档案
  .content-top {
    display: flex;
    .top_img {
      width: 100%;
      text-align: center;
    }
    .img {
      width: 75%;
      height: 220px;
      cursor: pointer;
    }
  }
  .top_value {
    margin: auto 5px;
    display: flex;
    flex-direction: column;
  }
  .content-buttom {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
  }
  .item_value {
    display: inline-flex;
    padding-bottom: 20px;
    .label {
      width: 100px;
      text-align: right;
    }
  }
  .paddingL10 {
    padding-left: 20px;
  }
  //通行记录
  .el-scrollbar {
    width: 100%;
    height: 100%;
  }
  .list-content {
    .list-item {
      border-bottom: 1px solid;
      @include set_theme_color(border-color, border-color);
    }
    .el-button {
      // color: #fff !important;
      font-size: 16px;
    }
    height: calc(100% - 50px);
    margin-top: 12px;
    .itemChildren {
      @include set_theme_color(background-color, page-default-bg);
      // background: #1e2534;
    }
    .item-title {
      // color: #fff !important;
      // background: #0d121c;
      padding: 8px 9px;
      cursor: pointer;
      .btn {
        display: none;
      }
      &:hover {
        .btn {
          display: inline-block;
        }
      }
    }
    .item-name {
      width: 70%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .item-over {
      width: 80% !important;
    }
    .list-text {
      padding: 8px 9px;
      // color: #9aa6c1;
      // background: #1e2534;
      border-bottom: 1px solid #3b4253;
      @include set_theme_color(border-color, border-color);

      .item-btn {
        display: none;
      }
      &:hover {
        // background: #0d121c;
        .liveImg {
          display: none;
        }
        .item-btn {
          display: inline-block;
        }
      }
      &.check {
        background: #0d121c;
      }
    }
    .list-text:last-child {
      border-bottom: none;
    }
    .item-title,
    .list-text {
      font-size: 14px;
      height: 40px;
      font-weight: 400;
      // line-height: 14px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .video-tab {
    width: 100%;
    display: flex;
    .tab {
      // color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 2px solid #707070;
      &:hover {
        @include set_theme_color(color, font-active-color);
        cursor: pointer;
      }
    }
    .active {
      @include set_theme_color(color, font-active-color);
      // color: #fff;
      border-color: #407aee;
    }
  }
  .record-list {
    height: calc(100% - 20px);
    padding: 12px 0;
    .scroll-list {
      .list-item {
        cursor: pointer;
        margin-bottom: 10px;
        display: flex;
        padding: 12px 16px;
        @include set_theme_color(background, page-default-bg);

        border-radius: 5px;
        &:hover {
          // @include set_theme_color(background-color, item-active-bg-color);
          @include set_theme_color(background, map-panel-active);
          color: #fff !important;
          div,
          span {
            color: #fff !important;
          }
        }
        .item_detail {
          padding-left: 12px;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .detail_header {
          display: flex;
          justify-content: space-between;
        }
        .detail_value {
          font-size: 12px;
          color: #9aa6c1;
        }
        .item_img {
          width: 70px;
          height: 70px;
          border-radius: 5px;
        }
      }
    }
  }

  .el-select-dropdown__item {
    width: 200px !important;
  }
  .getway-scenename {
    width: 200px;
    margin-bottom: 20px;
  }
  .getway-info-save {
    margin-left: 20px;
  }
  .getway-info {
    // height: 631px;
    height: 100%;
    // padding: 12px;
    // background: rgba(23, 28, 40, 1);
    .getway-info-line {
      flex: 1;
      display: flex;
      //margin-left: 14px;
      justify-content: space-around;
      // height: 450px;
      flex-wrap: wrap;
      &:last-child {
        margin-top: 10px;
      }
      .drag-content {
      }
    }
  }
  .getway-detail-table {
    // min-height: 200px;
    padding: 16px;
    width: 342px;
    margin-right: 14px;
    // flex: 1;
    display: flex;
    flex-direction: column;
    // margin-top: 10px;
    overflow: hidden;
    // background: #181f2e !important;
    position: relative;
    .table_tabs {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .el-tabs__nav-scroll {
      background: #181f2e !important;
    }
    .list-search {
      border: 1px solid #3e76e6;
      position: absolute;
      right: 20px;
      top: 40px;
      background: #fff;
      // background: rgba(40, 48, 70, 1);
      border-radius: 5px;
      padding: 6px 0px 0;
      cursor: pointer;
      z-index: 2;
      .search_item:hover {
        background: rgba(46, 134, 232, 0.7);
        color: #fff !important;
      }
      .search_item {
        padding: 10px;
        // color: #fff;
      }
      .check {
        color: #2b53a1 !important;
      }
    }
    .point-icon {
      // margin: auto 25px;
      cursor: pointer;
      position: absolute;
      top: 16px;
      right: 12px;
    }
    @include set_theme_color(background-color, table-odd-line-bg-color);
    .el-tabs__nav-scroll {
      @include set_theme_color(background-color, input-default-bg-color);
    }
    .el-tabs__nav {
      margin-left: 10px;
    }
    .search-area {
      position: absolute;
      right: 5px;
      top: 4px;
      width: 300px;
    }
  }
  .el-tabs__nav {
    width: 100% !important;
    display: flex;
    justify-content: space-around;
  }
  .el-tabs__active-bar {
    width: 86px !important;
  }
  .car-2 {
    .el-tabs__active-bar {
      transform: translateX(100px) !important;
    }
  }
  .car-3 {
    .el-tabs__active-bar {
      transform: translateX(225px) !important;
    }
  }
}
</style>
